import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { FacebookShareButton, TwitterShareButton, FacebookIcon } from "react-share";

interface Props {
  title: string;
  url: string;
}

export const ShareToSNS: React.FC<Props> = ({ title, url }) => {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `);

  const sharedUrl = `${site.siteMetadata.siteUrl}${encodeURI(url)}`;

  const iconSize = 40;
  return (
    <>
      <style jsx>{`
        .sns {
          display: flex;
          align-items: center;
          gap: 10px;
        }
        /* 両アイコンを同じサイズの枠で囲み、中身を 40x40 に強制（FB は画像参照・X は SVG で差が出るため） */
        .iconWrap {
          width: ${iconSize}px;
          height: ${iconSize}px;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }
        .iconWrap :global(> *) {
          width: ${iconSize}px !important;
          height: ${iconSize}px !important;
          min-width: ${iconSize}px !important;
          min-height: ${iconSize}px !important;
          max-width: ${iconSize}px !important;
          max-height: ${iconSize}px !important;
        }
        .iconWrap :global(.facebookShareButton),
        .iconWrap :global(.twitterShareButton) {
          display: flex !important;
          align-items: center;
          justify-content: center;
          outline: none;
          padding: 0;
          border: none;
          margin: 0;
        }
        .iconWrap :global(.facebookShareButton svg) {
          width: ${iconSize}px !important;
          height: ${iconSize}px !important;
        }
        .xIcon {
          width: ${iconSize}px;
          height: ${iconSize}px;
          border-radius: 50%;
          background-color: #000000;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: opacity 0.2s;
        }
        .xIcon:hover {
          opacity: 0.8;
        }
        .xIcon svg {
          width: 20px;
          height: 20px;
          fill: #ffffff;
        }
      `}</style>
      <div className="sns">
        <div className="iconWrap">
          <FacebookShareButton className="facebookShareButton" url={sharedUrl}>
            <FacebookIcon size={iconSize} round={true} />
          </FacebookShareButton>
        </div>
        <div className="iconWrap">
          <TwitterShareButton className="twitterShareButton" url={sharedUrl} title={title}>
            <div className="xIcon">
              <svg viewBox="0 0 24 24" aria-label="Xアイコン">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
              </svg>
            </div>
          </TwitterShareButton>
        </div>
      </div>
    </>
  );
};
